import { CheckboxGroup, RadioGroup } from "@caspeco/casper-ui-library";
import { MenuGroup, MenuGroupType } from "types/menu-group";

interface IPreorderGroupWrapper {
    children: React.ReactNode;
    menuGroup: MenuGroup;
}

/**
 * Some menu groups require a wrapper around the components.
 * Currently known group
 * SingelChoice => Radio Buttons
 * MultipleChoices => Checkbox
 * Todo: How to handle default selected?
 */
const PreorderGroupWrapper = ({ children, menuGroup }: IPreorderGroupWrapper) => {
    switch (menuGroup.groupType) {
        case MenuGroupType.SingleChoice:
            return <RadioGroup name={menuGroup.name}>{children}</RadioGroup>;
        case MenuGroupType.MultipleChoices:
            return <CheckboxGroup>{children}</CheckboxGroup>;
        default:
            return children;
    }
};

export default PreorderGroupWrapper;
